import { Box, Button, CircularProgress } from "@mui/material";
import { InputFileDropBox } from "components/inputs/InputFileDropBox";
import { ModalV1 } from "components/modals/ModalV1";
import { useState } from "react";
import { querySendApplicationDocumentNotice } from "service/api";

export const ModalUploadNotificationDocument = ({
  open,
  handleClose,
  assignmentId,
}: {
  open: boolean;
  handleClose: () => void;
  assignmentId: number;
}) => {
  const [file, setFile] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);

  const handleClickSend = async () => {
    try {
      setLoading(true);

      if (!file) return;
      const formData = new FormData();
      formData.set("file", file);
      await querySendApplicationDocumentNotice({
        assignmentId,
        formData,
      });
      handleClose();
      location.reload()
    } catch (error: any) {
      console.log(error);
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalV1
      open={open}
      handleClose={handleClose}
      title={"Загрузить документ-уведомление"}
      children={
        <>
          <InputFileDropBox
            description="Загрузить документ-уведомление"
            file={file}
            setFile={setFile}
          />
          <Box
            sx={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              onClick={handleClickSend}
              disabled={!file || loading}
              sx={{
                gap: "8px",
              }}
            >
              {loading ? <CircularProgress size={20} /> : null}
              {loading ? `Отправка...` : `Отправить`}
            </Button>
          </Box>
        </>
      }
    />
  );
};
